/**
 * Minimal text/event-stream framing: splits `buffer` on blank lines and returns the
 * `event:` names of complete frames plus the unfinished tail. Comments (`: ping`) and
 * frames without an event name are dropped — the release stream only sends `changed`.
 */
export const parseSse = (buffer: string): { events: string[]; rest: string } => {
  const frames = buffer.replace(/\r\n?/g, '\n').split('\n\n');
  const rest = frames.pop() ?? '';
  const events = frames.flatMap((frame) => {
    const line = frame.split('\n').find((l) => l.startsWith('event:'));
    return line ? [line.slice(6).trim()] : [];
  });
  return { events, rest };
};
